<template>
  <Activate />
</template>

<script setup>
import Activate from '@/sections/account/activate/activate.vue';
</script>
